import React, { useState, useEffect } from "react";
import PageHeader from '../../Components/shared/pageHeader/PageHeader'
// import LeadsCreateContent from '../../Components/leadsViewCreate/LeadsCreateContent'
import Footer from '../shared/Footer'
import Header from '../shared/header/Header'
import NavigationMenu from '../shared/navigationMenu/NavigationMenu'
import RoleCreate from './RoleCreate'
import Role2Header from './Role2Header'
import { useLocation } from "react-router-dom";
import { fetchData, fetchFormData } from "../../utils/options";
const EditRole = () => {
          const location = useLocation();
      const queryParams = new URLSearchParams(location.search);
      const id = queryParams.get("id");
      const [permission, setPermission] = useState(null);
    
      useEffect(() => {
        const getPermission = async () => {
          const roleId = localStorage.getItem("roleId");
          const id = queryParams.get("id");
    
          const formData = new FormData();
          formData.append("role_id", roleId);
          formData.append("module_id", id);
    
          try {
            const result = await fetchFormData("get-permission", formData, "POST");
            const perm = result?.data;
    
            setPermission(perm);
    
          } catch (error) {
            console.error("Error fetching permission", error);
          }
        };
    
        getPermission();
      }, [id]);
    return (
        <>

            <Header />
            <NavigationMenu />
            <main className="nxl-container">
                <div className="nxl-content">
                    <PageHeader>
                        <Role2Header permission={permission}/>
                    </PageHeader>

                    <div className='main-content'>
                        <div className='row'>
                            <RoleCreate permission={permission}/>
                        </div>
                    </div>
                    <Footer />
                </div>
            </main>

        </>
    )
}

export default EditRole